import type { WorkLogAttachment } from '@aegislab/shared';
import { formatFileSize, getFileIcon } from '@/shared/lib/file';
import { useRemoveAttachment } from '../../model/useAttachments';
import * as s from './FileAttachmentArea.css';

export interface FileAttachmentAreaProps {
  workLogId: string | undefined;
  attachments: WorkLogAttachment[];
  readonly?: boolean;
}

/**
 * 첨부 목록 띠. 파일 추가는 툴바 끝의 AttachFileButton 이 맡고, 이 띠는 첨부가 있을 때만 나타난다 —
 * 버튼 하나를 위해 띠 하나를 쓰면 모바일 하단이 두꺼워진다(2026-10-01 시안 C).
 */
export function FileAttachmentArea({
  workLogId,
  attachments,
  readonly = false,
}: FileAttachmentAreaProps) {
  const removeMutation = useRemoveAttachment();

  function handleRemove(attachmentId: string) {
    if (!workLogId) return;
    removeMutation.mutate({ workLogId, attachmentId });
  }

  if (attachments.length === 0) return null;

  return (
    <div className={s.container}>
      <span className={s.title}>첨부파일 ({attachments.length})</span>
      <div className={s.fileList}>
        {attachments.map((att) => {
          const Icon = getFileIcon(att.mimeType);
          return (
            <div key={att.id} className={s.fileItem}>
              <Icon size={14} weight="duotone" className={s.fileIcon} aria-hidden="true" />
              <span className={s.fileName}>{att.filename}</span>
              {att.size != null && <span className={s.fileSize}>{formatFileSize(att.size)}</span>}
              {!readonly && (
                <button
                  type="button"
                  className={s.removeButton}
                  onClick={() => handleRemove(att.id)}
                  disabled={removeMutation.isPending}
                  aria-label={`${att.filename} 삭제`}
                >
                  &times;
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
